<template>
  <div class="page-content">
    <div class="administrador-heading">
      <h5>{{ $t("lang.admin.printer_form.page_title") }}</h5>
    </div>
    <div class="centros-formbg">
      <h6>{{ $t("lang.admin.printer_form.add_form_title") }}</h6>
      <div class="centros-form">
        <div v-if="errors.length && !success.show">
          <b>{{ $t("lang.admin.printer_form.error_list_title") }}</b>
          <div class="alert alert-danger" role="alert">
            <ul style="list-style-type: circle;margin: 10px">
              <li v-for="(error, index) in errors" :key="index">{{ error }}</li>
            </ul>
          </div>
        </div>
        <div v-show="success.show">
          <div class="alert alert-success" role="alert">
            {{ success.message }}
          </div>
        </div>

        <form>
          <div class="form-row">
            <div class="select-box col-md-6">
              <v-select
                :items="tags"
                item-text="tag_type.reference"
                item-value="tag_type.id"
                v-model="selectedTag"
                prefix="Tag Type :   "
              ></v-select>
            </div>
            <div class="col-md-6">
                <v-select
                  :items="tagFormats"
                  item-text="tag_format.description"
                  item-value="tag_format.id"
                  v-model="selectedTagFormat"
                  prefix="Tag Format :   "
                ></v-select>
            </div>
            <div class="col-md-6">
              <v-file-input
                v-model="file"
                accept=".csv"
                show-size
                :label="$t('lang.admin.upload_file.select_file')"
                outlined
                truncate-length="50"
                prepend-icon="mdi-file"
                color="#FF5800"
              ></v-file-input>
            </div>
          </div>

          <div class="form-row">
            <div class="mb-0 col-md-12">
              <v-btn
                text
                rounded
                @click="$router.push({ name: 'PrintersList' })"
                >{{ $t("lang.location_form.btn_cancel") }}</v-btn
              >
              <bx-btn type="submit" color="primary" @click="submitForm">{{
                $t("lang.admin.printer_form.btn_done")
              }}</bx-btn>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "GeneratePrinterOrder",
  data() {
    return {
      tags: [],
      tagFormats: [],
      selectedTagFormat: null,
      file: null,
      selectedPrinter: null,
      errors: [],
      success: {
        show: false,
        message: this.$t("lang.admin.printer_form.success_add_printer_order")
      },
      errorLabels: {
        failed: this.$t("lang.messages.label_something_went_wrong")
      }
    };
  },
  async mounted() {
    this.user = await this.$api.printer.printer_user(
      this.$store.state.user.user
    );
    this.tags = await this.$api.printer.printer_tagtype();
    this.tagFormats = await this.$api.printer.printer_tagtype({tag_type: this.selectedTag});
    
  },
  methods: {
    async submitForm() {

        this.companyFormat = await this.$api.printer.printer_tagtype({
          tag_type: this.selectedTag,
          tag_format: this.selectedTagFormat,
          limit: 10
        }); 
        try {
          const res = await this.$api.printer.printUploadedFileNEW(
                  this.companyFormat.results[0].id,
                  this.user.company,
                  this.file);
        } catch (error) {
          this.errors.push(this.errorLabels.failed);
          console.error(error);
        } finally {
          this.success.show = true;
        }
    },
  }
};
</script>